import { usePermissions } from './usePermissions'

export function useRfqPermissions() {
  const { hasPermission, hasAnyPermission, hasAllPermissions } = usePermissions()
  
  // Specific RFQ permission checks
  const canViewQuotations = () => hasAnyPermission(['Supplier.Quotations'])

  const canEditQuotations = () => hasAnyPermission(['Supplier.Quotations.Edit'])
  const canApproveQuotations = () => hasAnyPermission(['Supplier.Quotations.Approve'])
  const canExportQuotations = () => hasAnyPermission(['Supplier.Quotations.Export'])
  const canDeleteQuotations = () => hasAnyPermission(['Supplier.Quotations.Delete'])
  
  // Combined permission checks
  const canAccessRfq = () => hasAnyPermission([
    'Supplier.Quotations.ViewDetails',
    'Supplier.Quotations.Create',
    'Supplier.Quotations.Edit',
    'Supplier.Quotations.Approve',
    'Supplier.Quotations'
  ])
  
  const canManageQuotations = () => hasAnyPermission([
    'Supplier.Quotations.Create',
    'Supplier.Quotations.Edit',
    'Supplier.Quotations.Delete',
    'Supplier.Quotations'
  ])
  
  const isQuotationAdmin = () => hasAnyPermission([
    'Supplier.Quotations'
  ]) || hasAllPermissions([
    'Supplier.Quotations.ViewDetails',
    'Supplier.Quotations.Create',
    'Supplier.Quotations.Edit',
    'Supplier.Quotations.Approve',
    'Supplier.Quotations.Export',
    'Supplier.Quotations.Delete'
  ])
  
  return {
    // Individual permissions
    canViewQuotations,
    canEditQuotations,
    canApproveQuotations,
    canExportQuotations,
    canDeleteQuotations,
    
    // Combined permissions
    canAccessRfq,
    canManageQuotations,
    isQuotationAdmin,
    
    // Direct access to base permission functions
    hasPermission,
    hasAnyPermission,
    hasAllPermissions
  }
} 